const columns = () => {
  return [
    {
      formItem: {
        type: "hidden",
      },
      name: "id",
      dataIndex: 'userName',
    },
    {
      title: "账号",
      name: "userName",
      dataIndex: "userName",
      searchItem: {},
      tableItem: {
        width: 100
      },
    },
    {
      title: "姓名",
      name: "fullName",
      dataIndex: "fullName",
      searchItem: {},
      tableItem: {
        width: 100
      },
    },
    {
      title: "手机号",
      name: "mobile",
      dataIndex: "mobile",
      tableItem: {},
      width: 130
    },
    {
      title: "证件号码",
      name: "idCard",
      dataIndex: "idCard",
      tableItem: {
        width: 220
      },
    },
    {
      title: "用户属性",
      name: "userType",
      dataIndex: "userType",
      tableItem: {
        width: 150
      },
      dict: [
        { code: 0, codeName: "培训平台用户" },
        { code: 5, codeName: "服务商用户" },
        { code: 4, codeName: "经销商用户" },
        { code: 3, codeName: "OEM部门用户" }
      ]
    },
    {
      title: "状态",
      name: "status",
      dataIndex: "status",
      tableItem: {
        width: 100
      },
      dict: [
        {code: 0, codeName: "未签到"},
        {code: 1, codeName: "已签到"},
        {code: 2, codeName: "补签"}
      ]
    },


  ]
};

const tableApi = (api = {}) => {
  return {
    path: 'studentSign/listByPage',
    ...api
  }
};

const classStudentSign = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowTitle: 'userName',
    rowName: 'fullName',
    columns: columns(),
    tableApi: tableApi(api)
  }
};

export default classStudentSign
